export default __webpack_public_path__ + "static/media/nfc.1e1c9c72.svg";